module.exports = __webpack_public_path__ + "img/philips_mx800.1fd935d3.png";